import { ComponentPropsWithoutRef, ReactNode } from 'react';

import classNames from 'classnames';
import { Command } from 'cmdk';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxEmptyProps extends ComponentPropsWithoutRef<'div'> {
  children?: ReactNode;
}

export const ComboboxEmpty = ({ className, children, ...rest }: ComboboxEmptyProps) => {
  const { classNames: contextClassNames } = useComboboxContext();
  const styles = comboboxStyles();

  return (
    <Command.Empty
      {...rest}
      className={classNames(styles.empty(), contextClassNames?.empty, className)}
    >
      {children}
    </Command.Empty>
  );
};
